import { render, staticRenderFns } from "./TypeSelect.vue?vue&type=template&id=bb275e08&"
import script from "./TypeSelect.vue?vue&type=script&lang=js&"
export * from "./TypeSelect.vue?vue&type=script&lang=js&"
import style0 from "./TypeSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports